<template>
  <AppPage>
    <AppHeader
        :title="pageTitle"
        left-icon="question-circle"
        :left-action="()=>$router.push('/help')"
        :right-action="addOrder"
        :right-icon="rightIcon"
        :hide-number="!hasOrder"
    />
    <!-- <div class="logo text-center">
      <img src="http://immsoluciones.com/wp-content/uploads/2018/02/HB_gris.png">
    </div> -->
    <UserAvatar @click.native="onLogout" />
    <template v-if="numLines > 0">
      <AppSection title="PEDIDO GUARDADO">
        <div class="alert alert-success text-center" @click="addOrder">
          <i class="fa fa-folder" />
          <br>
          Tienes <strong>{{numLines}}</strong> articulos en la cesta.
          <br>
          <span>Pulsa sobre este mensaje para continuar con tu pedido.</span>
        </div>
      </AppSection>
    </template>

    <AppSection class="text-center" v-else>
      <div class="alert alert-success text-center" @click="addOrder">
        <i class="fa fa-plus" />
        <br>
        <span>
          Pulsa sobre este mensaje empezar con un pedido nuevo.
        </span>
      </div>
    </AppSection>

    <AppSection title="ULTIMOS PEDIDOS">
      <template v-if="user && user.email">
        <div
            class="alert alert-warning text-center"
            v-if="orders.length === 0"
            @click="addOrder"
        >
          <i class="fa fa-exclamation-circle" />
          <p>
            Aún no has realizado ningún pedido con nosotros.
            <strong>Pulsa sobre este mensaje</strong> <br>
            <strong v-if="numLines === 0">para empezar uno nuevo.</strong>
            <strong v-else>para continuar con tu pedido.</strong>
          </p>
        </div>
        <div v-else
             class="card user-order"
             v-for="order in orders"
             :key="order.key"
        >
          <div class="card-body user-order-detail">
            <div class="user-order-detail__details" @click="viewOrdenDetail(order.key)">
              <small class="capitalize">{{orderDateFromNow(order)}}</small>
              <div class="capitalize">{{orderDate(order)}}</div>
              <small class="capitalize" v-if="order.location">{{order.location.address}}</small>
              <div>
                <small class="text-muted">Total:</small>
                {{order.total}}€
              </div>
            </div>
            <i class="fa fa-chevron-right" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="alert alert-warning text-center">
          <i class="fa fa-exclamation-circle" />
          <p>
            <span>Si quieres guardar un histórico de pedidos puedes registrar sesión con tus redes sociales.</span>
          </p>
        </div>
      </template>
    </AppSection>
  </AppPage>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import 'moment/locale/es'
import { orderBy } from 'lodash'

import { usersRef } from '../../firebase'
import UserAvatar from './UserAvatar'
import NewOrderMessage from '../Order/NewOrderMessage'

export default {
  components: { NewOrderMessage, UserAvatar },
  computed: {
    user() {
      return this.$store.state.profile.user
    },
    pageTitle() {
      return this.user && this.email ? 'PERFIL DE USUARIO' : 'USUARIO ANONIMO'
    },
    hasOrder() {
      const profile = this.$store.state.profile
      return profile && profile.order
    },
    rightIcon() {
      return this.hasOrder ? 'folder' : 'plus'
    },
    numLines() {
      return this.$store.state.profile.order
        ? Object.keys(this.$store.state.profile.order).length
        : 0
    },
    orders() {
      let _orders = this.$store.state.profile.orders || []
      let keys = Object.keys(_orders)
      let values = Object.values(_orders)
      let orders = keys.map((o, i) => ({
        key: o,
        ...values[i]
      }))

      orders = orderBy(orders, 'date').reverse()

      return orders || []
    }
  },
  methods: {
    async repeatOrder(products) {
      let res = await window.confirm('¿Quieres repetir el pedido?')
      if (res) {
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order')
          .set(products)
        this.$router.push('/order')
      }
    },
    viewOrdenDetail(key) {
      this.$router.push(`/order/${key}`)
    },
    orderDate(order) {
      return moment(order.date).format('dddd DD MMMM - HH:mm[h]')
    },
    orderDateFromNow(order) {
      return moment(order.date).fromNow()
    },
    onLogout() {
      if (
        window.confirm(
          '¿Deseas cerrar la sesión e iniciar con un usuario distinto?'
        )
      ) {
        firebase
          .auth()
          .signOut()
          .catch(console.error)
      }
    },
    async addOrder(e, clear = false) {
      if (clear) {
        const res = await window.confirm(
          '¿QUIERES DESESTIMAR EL PEDIDO EN CURSO Y EMPEZAR UNO NUEVO?'
        )
        if (!res) return
        const uid = this.$store.state.profile.user.uid
        usersRef
          .child(uid)
          .child('order')
          .set(null)
          .then(() => {
            this.$store.commit('isLoading', true)
            this.$router.push('/location')
          })
      } else {
        this.$store.commit('isLoading', true)
        this.$router.push(this.hasOrder ? '/catalog' : '/location')
      }
    }
  }
}
</script>

<style lang="scss">
.logo {
  img {
    width: 80px;
  }
}
.user-order {
  align-items: flex-start;
  background-color: white;
  border-left: 4px solid #35383d;
  border-radius: 0.2rem;
  display: flex;
  margin-bottom: 0.42em;

  &-detail {
    width: 100%;
    display: flex;
    align-items: center;

    &__details {
      flex: 1;
      margin-left: 0.4rem;
      margin-right: 1.2rem;
    }

    .btn-sm {
      small {
        display: block;
        font-size: 8px;
      }
    }
  }
}

.btn-add {
  margin-bottom: 1rem;
}

.capitalize {
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/User/UserProfile.vue